import { message } from 'ant-design-vue'
import { OkrSuccessIcon, OkrErrorIcon } from '@/components/icon'
message.config({
  duration: 2
})
function useMessage() {}
let oldSuccess = message.success
let oldError = message.error
message.success = function (config) {
  if (typeof config == 'string' || typeof config == 'number') {
    config = {
      content: config
    }
  }
  return oldSuccess({
    icon: OkrSuccessIcon,
    class: 'share-success-message',
    ...config
  })
}
message.error = function (config) {
  if (typeof config == 'string' || typeof config == 'number') {
    config = {
      content: config
    }
  }
  return oldError({
    icon: OkrErrorIcon,
    class: 'share-error-message',
    ...config
  })
}
useMessage.message = message
export { useMessage }
